import angular from 'angular';
import f from 'odata-filter-builder';
import { transformODataResponse } from 'utilities/query';

import {
  USER_ADDED,
  USER_EDITED,
  USER_DELETED,
  ACCOUNT_EDITED,
  ACCOUNT_LOCKOUT_EDITED,
  PASSWORD_CHANGED
} from 'common/messages';
import templateUrl from './company.html';

export default {
  templateUrl,
  bindings: {
    accessLevels: '<',
    company: '<',
    user: '<'
  },
  controller: class CompanyComponent {
    constructor($mdDialog, $scope, $state, AccountService,
      ArrayService, CompanyService, AuthService,
      PeopleService, ToastService) {
      'ngInject';

      Object.assign(this, {
        $mdDialog,
        $scope,
        $state,
        AccountService,
        ArrayService,
        CompanyService,
        AuthService,
        PeopleService,
        ToastService
      });
    }

    $onInit() {
      this.selectedUsers = [];

      this.query = {
        ...this.PeopleService.getDefaultQuery()
      };

      this.refreshResults();
    }

    userAdd() {
      const scope = angular.extend(this.$scope.$new(true), {
        accessLevels: this.accessLevels,
        onUserChanged: $event => this.onUserAdded($event)
      });

      this.$mdDialog.show({
        clickOutsideToClose: true,
        fullscreen: true,
        scope,
        template: `
          <md-dialog class="flex-50">
            <md-dialog-content>
              <dialog-close/>
              <user-add-form
                require-user-type-selection="false"
                access-levels="accessLevels"
                on-user-changed="onUserChanged($event)">
              </user-add-form>
            </md-dialog-content>
          </md-dialog>
          `
      });
    }

    onUserAdded({ user }) {
      if (user) {
        this.AccountService.addAccount({
          ...user,
          TypeReferenceId: this.company.MemberId,
          UserTypeId: 1
        }).then(() => {
          this.ToastService.showSuccess(USER_ADDED);
          this.$mdDialog.hide();
          this.refreshResults();
        }).catch(error => this.ToastService.showError(error));
      }
    }

    userEdit(user) {
      const scope = angular.extend(this.$scope.$new(true), {
        accessLevels: this.accessLevels,
        user: angular.copy(user),
        onUserChanged: $event => this.onUserEdited($event)
      });

      this.$mdDialog.show({
        clickOutsideToClose: true,
        fullscreen: true,
        scope,
        template: `
          <md-dialog class="flex-50">
            <md-dialog-content>
              <dialog-close/>
              <user-edit-form
                user="user"
                access-levels="accessLevels"
                show-access-level="true"
                on-user-changed="onUserChanged($event)">
              </user-edit-form>
            </md-dialog-content>
          </md-dialog>
          `
      });
    }

    onUserEdited({ user }) {
      if (user) {
        this.AccountService.updateAccount(user)
          .then(() => {
            this.ToastService.showSuccess(USER_EDITED);
            this.$mdDialog.hide();
            this.refreshResults();
          }).catch(error => this.ToastService.showError(error));
      }
    }

    userDelete(users) {
      const confirm = this.$mdDialog.confirm()
        .title('Are you sure?')
        .textContent('Once deleted, the selected user(s) cannot be recovered!')
        .ok('Delete')
        .cancel('Cancel');

      this.$mdDialog.show(confirm).then(() => {
        const promises = [];
        for (let i = users.length - 1; i >= 0; i -= 1) {
          promises.push(this.AccountService.deleteAccount(users[i].UserId));
        }

        Promise.all(promises).then(() => {
          this.ToastService.showSuccess(USER_DELETED);
          this.refreshResults();
        }).catch(error => this.ToastService.showError(error));
      });
    }

    updateCompany({ company }) {
      if (company) {
        this.CompanyService.update(company)
          .then(() => {
            this.ToastService.showSuccess(ACCOUNT_EDITED);
            this.$state.reload();
          }).catch(error => this.ToastService.showError(error));
      }
    }

    updateAccount({ user }) {
      if (user) {
        this.AccountService.updateAccount(user)
          .then(() => {
            this.ToastService.showSuccess(ACCOUNT_EDITED);
            this.$state.reload();
          }).catch(error => this.ToastService.showError(error));
      }
    }

    showChangePassword(user) {
      const scope = angular.extend(this.$scope.$new(true), {
        passwordChanged: $event => this.onPasswordChanged($event),
        credentials: {
          UserId: user.UserId
        }
      });

      this.$mdDialog.show({
        clickOutsideToClose: true,
        fullscreen: true,
        scope,
        template: `
          <md-dialog class="flex-50">
            <md-dialog-content>
              <dialog-close/>
              <change-password
                password-changed="passwordChanged($event)"
                require-current-password="false"
                credentials="credentials">
              </change-password>
            </md-dialog-content>
          </md-dialog>
          `
      });
    }

    onPasswordChanged({ credentials }) {
      if (credentials) {
        this.AccountService.forcePasswordChange({
          ...credentials
        }).then(() => {
          this.$mdDialog.hide();
          this.ToastService.showSuccess(PASSWORD_CHANGED);
          this.selectedUsers = [];
        }).catch(error => this.ToastService.showError(error));
      }
    }

    setUserLockout({ userId, isLocked }) {
      this.AccountService.setLockoutStatus(userId, isLocked)
        .then(() => {
          this.ToastService.showSuccess(ACCOUNT_LOCKOUT_EDITED);
        }).catch(error => this.ToastService.showError(error));
    }

    onSearchTextChanged({ searchText }) {
      this.searchText = searchText;
      this.refreshResults();
    }

    onQueryChanged({ query }) {
      this.query = query;
      this.refreshResults();
    }

    refreshResults() {
      this.selectedUsers = [];
      let filter = f();

      if (this.searchText && this.searchText.length) {
        filter = filter.contains('LastName', this.searchText)
          .or(x => x.contains('FirstName', this.searchText));
      }

      filter = filter.and(x => x.eq('UserTypeName', 'Member'))
        .and(x => x.ne('UserId', this.user.UserId))
        .and(x => x.eq('TypeReferenceId', this.$state.params.id));

      this.promise = this.PeopleService.search({
        ...this.query,
        filter
      });

      this.promise.then((r) => {
        this.users = transformODataResponse(r);
      }).catch(error => this.ToastService.showError(error));
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/company/company.component.js